export const isProduction = () => {
  const hostname = window && window.location && window.location.hostname;
  return hostname === 'pulsoid.net';
};

export const resolveRpcUrl = (isPublic = false) => {
  if (isProduction()) {
    return `https://pulsoid.net/v1/api/${isPublic ? 'public/' : ''}rpc`;
  } else {
    return `/v1/api/${isPublic ? 'public/' : ''}rpc`;
  }
};

// TODO: move it to constatnt
export const PROD_HOST_NAME = 'https://pulsoid.net';

export const redirectToAuth = ({
  backUrl = window.location.href,
  registration = false,
  newTab = false,
  isReplace = false,
}: {
  backUrl?: string;
  registration?: boolean;
  isReplace?: boolean;
  newTab?: boolean;
} = {}) => {
  const subroute = registration ? 'registration' : 'login';
  const target = newTab ? '_blank' : '_self';
  const redirect = (url: string) =>
    isReplace ? window.location.replace(url) : window.open(url, target);

  if (isProduction()) {
    redirect(`${PROD_HOST_NAME}/${subroute}?redirect=${backUrl}`);
  } else {
    redirect(`http://localhost:9000/${subroute}?redirect=${backUrl}`);
  }
};
